<template scrolling="no">
  <div class="typeform">
    <html>
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <title>Social Isolation Assessment Survey</title>
      </head>
      <body role="application">
        <iframe
          src="https://www.videoask.com/f6ydcvqmu"
          allow="camera *; microphone *; autoplay *; encrypted-media *;"
          width="100%"
          height="600px"
          class="videoask"
          style="border: none;    height:100%; z-index:2"
        >
        </iframe>
        <!-- <iframe src="https://www.videoask.com/f6ydcvqmu"
  allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
  width="100%"
  height="600px"
  style="border: none; border-radius: 24px"
>
</iframe> -->

      </body>
    </html>
  </div>
</template>

<script>
export default {
  name: "Assessment",
  data() {
    return {};
  },
};
</script>

<style scoped>
/* FULL PAGE TYPEFORM */
html {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
iframe {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border: 0;
  padding: 8rem;
}

@media screen and (max-width: 600px) {
  iframe {
    padding: 0 !important;
  }
}

.v-application--wrap {
  overflow: hidden;
}
</style>
